package com.parmartechnologies.core.feature.auth.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Language(
    @SerialName("code") var code: String = "",
    @SerialName("name") var name: String = "",
)